import { ReactElement } from "react";
import styles from "./ImageWithFocalPoint.module.less";
import classNames from "classnames";
import { FocalPoint } from "./FocalPointDialog";
import { useCallbackWithoutArguments } from "client/Hooks";

export type ImageWithFocalPointProps = {
	src: string;
	focalPoint: FocalPoint;
	height?: "auto" | "fill";
	alt?: string;
	onError?: () => void;
};

export const ImageWithFocalPoint = (props: ImageWithFocalPointProps): ReactElement => {
	const {
		focalPoint,
		src,
		height = "auto",
		alt,
		onError
	} = props;

	const errorHandler: (() => void) | undefined = useCallbackWithoutArguments(onError);

	return (
		<img
			className={
				classNames(
					styles.root,
					{
						[styles.root_fillHeight]: height === "fill"
					}
				)
			}
			src={src}
			style={{
				"--_focal-point-x": focalPoint.left,
				"--_focal-point-y": focalPoint.top
			}}
			alt={alt}
			onError={errorHandler}
		/>
	);
};
ImageWithFocalPoint.displayName = "ImageWithFocalPoint";